var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUzbekistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13761_68423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 -0.00250244H0V15.995H24V-0.00250244Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 11.1274H0V15.9949H24V11.1274Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 -0.00250244H0V4.895H24V-0.00250244Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 5.88501H0V10.085H24V5.88501Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 -0.00250244H0V4.895H24V-0.00250244Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84248 2.45C2.84939 2.0982 2.97447 1.75896 3.19758 1.48688C3.42069 1.21479 3.72886 1.02569 4.07248 0.949997C3.96029 0.938136 3.84717 0.938136 3.73498 0.949997C3.31925 0.949997 2.92055 1.11514 2.62659 1.40911C2.33263 1.70307 2.16748 2.10177 2.16748 2.5175C2.16748 2.93322 2.33263 3.33192 2.62659 3.62589C2.92055 3.91985 3.31925 4.085 3.73498 4.085C3.84717 4.09686 3.96029 4.09686 4.07248 4.085C3.70562 4.00497 3.37967 3.79591 3.15394 3.49585C2.92821 3.19579 2.81768 2.82467 2.84248 2.45Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99523 3.16248L5.10773 3.48498H5.44523L5.16773 3.68748L5.28023 4.01748L4.99523 3.81498L4.71773 4.01748L4.83023 3.68748L4.55273 3.48498H4.89023L4.99523 3.16248Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09746 3.16248L6.20246 3.48498H6.53996L6.26246 3.68748L6.37496 4.01748L6.09746 3.81498L5.81996 4.01748L5.92496 3.68748L5.64746 3.48498H5.98496L6.09746 3.16248Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18518 3.16248L7.29768 3.48498H7.63518L7.35768 3.68748L7.46268 4.01748L7.18518 3.81498L6.90768 4.01748L7.02018 3.68748L6.74268 3.48498H7.08018L7.18518 3.16248Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28039 3.16248L8.38539 3.48498H8.73039L8.45289 3.68748L8.55789 4.01748L8.28039 3.81498L8.00289 4.01748L8.11539 3.68748L7.83789 3.48498H8.17539L8.28039 3.16248Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37529 3.16248L9.48029 3.48498H9.82529L9.54779 3.68748L9.65279 4.01748L9.37529 3.81498L9.09779 4.01748L9.20279 3.68748L8.92529 3.48498H9.27029L9.37529 3.16248Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09746 2.02252L6.20246 2.35252H6.53996L6.26246 2.54752L6.37496 2.87752L6.09746 2.67502L5.81996 2.87752L5.92496 2.54752L5.64746 2.35252H5.98496L6.09746 2.02252Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18518 2.02252L7.29768 2.35252H7.63518L7.35768 2.54752L7.46268 2.87752L7.18518 2.67502L6.90768 2.87752L7.02018 2.54752L6.74268 2.35252H7.08018L7.18518 2.02252Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28039 2.02252L8.38539 2.35252H8.73039L8.45289 2.54752L8.55789 2.87752L8.28039 2.67502L8.00289 2.87752L8.11539 2.54752L7.83789 2.35252H8.17539L8.28039 2.02252Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37529 2.02252L9.48029 2.35252H9.82529L9.54779 2.54752L9.65279 2.87752L9.37529 2.67502L9.09779 2.87752L9.20279 2.54752L8.92529 2.35252H9.27029L9.37529 2.02252Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18518 0.882507L7.29768 1.21251H7.63518L7.35768 1.41501L7.46268 1.73751L7.18518 1.53501L6.90768 1.73751L7.02018 1.41501L6.74268 1.21251H7.08018L7.18518 0.882507Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28039 0.882507L8.38539 1.21251H8.73039L8.45289 1.41501L8.55789 1.73751L8.28039 1.53501L8.00289 1.73751L8.11539 1.41501L7.83789 1.21251H8.17539L8.28039 0.882507Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37529 0.882507L9.48029 1.21251H9.82529L9.54779 1.41501L9.65279 1.73751L9.37529 1.53501L9.09779 1.73751L9.20279 1.41501L8.92529 1.21251H9.27029L9.37529 0.882507Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13761_68423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzbekistan);
export default __webpack_public_path__ + "static/media/Uzbekistan.c1148f90636a1de98f29725be3cbef98.svg";
export { ForwardRef as ReactComponent };